import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { lazy } from 'react';
import { getConf, ConfigurationReference } from '@jbrowse/core/configuration';
import { getSession } from '@jbrowse/core/util';
import { types, getEnv } from 'mobx-state-tree';
// icons
import VisibilityIcon from '@mui/icons-material/Visibility';
// locals
import { BaseLinearDisplay } from '../BaseLinearDisplay';
var SetMaxHeightDlg = lazy(function () {
  return import('./components/SetMaxHeight');
});
/**
 * #stateModel LinearBasicDisplay
 * used by `FeatureTrack`, has simple settings like "show/hide feature labels",
 * etc.
 */
function stateModelFactory(configSchema) {
  return types.compose('LinearBasicDisplay', BaseLinearDisplay, types.model({
    /**
     * #property
     */
    type: types.literal('LinearBasicDisplay'),
    /**
     * #property
     */
    trackShowLabels: types.maybe(types.boolean),
    /**
     * #property
     */
    trackShowDescriptions: types.maybe(types.boolean),
    /**
     * #property
     */
    trackDisplayMode: types.maybe(types.string),
    /**
     * #property
     */
    trackMaxHeight: types.maybe(types.number),
    /**
     * #property
     */
    configuration: ConfigurationReference(configSchema)
  })).views(function (self) {
    return {
      /**
       * #getter
       */
      get rendererTypeName() {
        return getConf(self, ['renderer', 'type']);
      },
      /**
       * #getter
       */
      get showLabels() {
        var _a;
        return (_a = self.trackShowLabels) !== null && _a !== void 0 ? _a : getConf(self, ['renderer', 'showLabels']);
      },
      /**
       * #getter
       */
      get showDescriptions() {
        var _a;
        return (_a = self.trackShowDescriptions) !== null && _a !== void 0 ? _a : getConf(self, ['renderer', 'showDescriptions']);
      },
      /**
       * #getter
       */
      get maxHeight() {
        var _a;
        return (_a = self.trackMaxHeight) !== null && _a !== void 0 ? _a : getConf(self, ['renderer', 'maxHeight']);
      },
      /**
       * #getter
       */
      get displayMode() {
        var _a;
        return (_a = self.trackDisplayMode) !== null && _a !== void 0 ? _a : getConf(self, ['renderer', 'displayMode']);
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get rendererConfig() {
        var configBlob = getConf(self, ['renderer']) || {};
        var config = configBlob;
        return self.rendererType.configSchema.create(_objectSpread({}, config, {
          showLabels: self.showLabels,
          showDescriptions: self.showDescriptions,
          displayMode: self.displayMode,
          maxHeight: self.maxHeight
        }), getEnv(self));
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      toggleShowLabels: function toggleShowLabels() {
        self.trackShowLabels = !self.showLabels;
      },
      /**
       * #action
       */
      toggleShowDescriptions: function toggleShowDescriptions() {
        self.trackShowDescriptions = !self.showDescriptions;
      },
      /**
       * #action
       */
      setDisplayMode: function setDisplayMode(val) {
        self.trackDisplayMode = val;
      },
      /**
       * #action
       */
      setMaxHeight: function setMaxHeight(val) {
        self.trackMaxHeight = val;
      }
    };
  }).views(function (self) {
    var superTrackMenuItems = self.trackMenuItems,
      superRenderProps = self.renderProps;
    return {
      /**
       * #method
       */
      renderProps: function renderProps() {
        var config = self.rendererConfig;
        var superProps = superRenderProps();
        var superPropsOmit = superProps;
        return _objectSpread({}, superPropsOmit, {
          config: config
        });
      },
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        return [].concat(_toConsumableArray(superTrackMenuItems()), [{
          label: 'Show labels',
          icon: VisibilityIcon,
          type: 'checkbox',
          checked: self.showLabels,
          onClick: function onClick() {
            return self.toggleShowLabels();
          }
        }, {
          label: 'Show descriptions',
          icon: VisibilityIcon,
          type: 'checkbox',
          checked: self.showDescriptions,
          onClick: function onClick() {
            return self.toggleShowDescriptions();
          }
        }, {
          label: 'Display mode',
          icon: VisibilityIcon,
          subMenu: ['compact', 'reducedRepresentation', 'normal', 'collapse'].map(function (val) {
            return {
              label: val,
              onClick: function onClick() {
                return self.setDisplayMode(val);
              }
            };
          })
        }, {
          label: 'Set max height',
          onClick: function onClick() {
            getSession(self).queueDialog(function (handleClose) {
              return [SetMaxHeightDlg, {
                model: self,
                handleClose: handleClose
              }];
            });
          }
        }]);
      }
    };
  });
}
export default stateModelFactory;